var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-section-header" }, [
    _c("h2", { staticClass: "c-section-header__title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-section-header__description" }, [
      _c("p", [_vm._v(_vm._s(_vm.desc))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a78921f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a78921f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/report-a-problem/_vue/SectionHeader.vue
// module id = 700
// module chunks = 0